import { render, staticRenderFns } from "./ScheduleIcon.vue?vue&type=template&id=3bcf041b"
import script from "./ScheduleIcon.vue?vue&type=script&lang=js"
export * from "./ScheduleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports